import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import { createRpcClientV2 } from 'rpc-client-utils';
import { getByHubRpc } from '../../__generated__/chirp/com/hubspot/teams/rpc/AppFatTeams';
import { captureException } from '../utils/sentryUtils';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});
const APP_TEAMS_FIELD = 'appTeams';
const EMPTY_TEAMS_RECORD = {};
const FETCH_APP_TEAMS = registerQuery({
  fieldName: APP_TEAMS_FIELD,
  fetcher: async () => {
    const {
      fatTeams
    } = await chirpClient.call(getByHubRpc, {
      request: {}
    });
    return fatTeams.map(team => ({
      id: team.id,
      name: team.name,
      userIds: team.userIds
    }));
  }
});
export const useAppTeams = ({
  enabled = true
} = {}) => {
  const {
    data,
    loading,
    error
  } = useQuery(FETCH_APP_TEAMS, {
    skip: !enabled,
    // CHIRP migration: verify error shape is handled correctly here. Hook/DFC
    // errors are wrapped by ApolloError (ChirpError at error.cause.cause). We
    // only capture the error and fall back to an empty record, so no .cause
    // access is required.
    onError: err => {
      captureException(err, {
        extra: {
          fingerprint: 'useAppTeams-fetch'
        }
      });
    }
  });
  const teamsRecord = useMemo(() => {
    const teams = data === null || data === void 0 ? void 0 : data[APP_TEAMS_FIELD];
    if (!teams) {
      return EMPTY_TEAMS_RECORD;
    }
    return teams.reduce((record, team) => {
      record[String(team.id)] = team;
      return record;
    }, {});
  }, [data]);
  return {
    teamsRecord,
    loading,
    error
  };
};